import { Component, Input, OnInit } from '@angular/core';
import { TrackAuthority } from '../../models/trackauthority';
import { Direction } from '../../models/direction.enum';

@Component({
  selector: 'authority-card',
  templateUrl: './authority-card.component.html',
  styleUrls: ['./authority-card.component.scss']
})
export class AuthorityCardComponent {
  @Input() authority: TrackAuthority;
  Direction = Direction;
}
